<template>
    <hsc-menu-style-white>
        <hsc-menu-bar light style="border-radius: 0 0 8pt 0; color:white; background-color: #ffffff00;box-shadow: 0 0 0 rgba(0, 0, 0, 0)">
            <v-icon v-on="on" small class="mb-1 mr-0" color="#81DBF6">mdi-finance</v-icon>
            <span @click="$router.push('/home')" class="mx-2" light>Dashboard</span>
            <v-icon v-if="show(999)" v-on="on" small class="mb-1 mr-0" color="#81DBF6">mdi-handshake</v-icon>
            <hsc-menu-bar-item v-if="show(999)" light label="Deals">
              <hsc-menu-item v-if="show(999)" label="Purchase">
                <hsc-menu-item v-if="show(102)" label="Bond" @click="$router.push('/dealing/bond_purchases')" />
                <hsc-menu-item v-if="show(101)" label="Equity" @click="$router.push('/dealing/equity_purchases')" />
                <hsc-menu-item v-if="show(103)" label="Money Market" @click="$router.push('/dealing/MM_purchases')" />
                <hsc-menu-item v-if="show(104)" label="Property" @click="$router.push('/dealing/property_purchases')" />
              </hsc-menu-item>
              <hsc-menu-item v-if="show(999)" label="Sell">
                <hsc-menu-item v-if="show(202)" label="Bond" @click="$router.push('/dealing/bond_sales')" />
                <hsc-menu-item v-if="show(201)" label="Equity" @click="$router.push('/dealing/equity_sales')" />
                <hsc-menu-item v-if="show(203)" label="Money Market" @click="$router.push('/dealing/MM_sales')" />
                <hsc-menu-item v-if="show(204)" label="Property" @click="$router.push('/dealing/property_sales')" />
              </hsc-menu-item>
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(3023)" label="Internal Asset Transfer" @click="$router.push('/dealing/internal_asset_transfer')" />
                <hsc-menu-item v-if="show(3031)" label="Reversals" @click="$router.push('/dealing/reversals')" />
                <!-- <hsc-menu-item v-if="show(243)" label="Bookover - Bond" />
                <hsc-menu-item v-if="show(241)" label="Bookover - Equity" />
                <hsc-menu-item v-if="show(222)" label="Bookover - Money Market" />
                <hsc-menu-item v-if="show(242)" label="Bookover - Property" /> -->
            </hsc-menu-bar-item>
            <v-icon v-if="show(999)" v-on="on" small class="mb-1 mr-0" color="#81DBF6">mdi-account-group</v-icon>
            <hsc-menu-bar-item v-if="show(323)" light label="Unit Trusts">
              <hsc-menu-item v-if="show(323)" label="Funds" @click="$router.push('/administration/unit_trust')"/>
              <hsc-menu-item v-if="show(323)" label="Redemption" @click="$router.push('/administration/unit_trust_redemption')"/>
              <hsc-menu-item v-if="show(323)" label="Subscription" @click="$router.push('/administration/unit_trust_subscription')"/>
              <hsc-menu-item v-if="show(323)" label="Distribution" @click="$router.push('/administration/unit_distribution')"/>
            </hsc-menu-bar-item>
            <!-- <v-icon v-if="show(205)" v-on="on" small class="mb-1" color="white">mdi-swap-horizontal-bold</v-icon>
            <hsc-menu-bar-item v-if="show(205)" label="Transfers">
                <hsc-menu-item v-if="show(107)" label="Transfer In - Bond" />
                <hsc-menu-item v-if="show(106)" label="Transfer In - Equity" />
                <hsc-menu-item v-if="show(108)" label="Transfer In - Money Market" />
                <hsc-menu-item v-if="show(109)" label="Transfer In - Property" />
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(207)" label="Transfer Out - Bond" />
                <hsc-menu-item v-if="show(206)" label="Transfer Out - Equity" />
                <hsc-menu-item v-if="show(208)" label="Transfer Out - Money Market" />
                <hsc-menu-item v-if="show(209)" label="Transfer Out - Property" />
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(213)" label="Transfer to Managed - Bond" />
                <hsc-menu-item v-if="show(212)" label="Transfer to Managed - Equity" />
                <hsc-menu-item v-if="show(214)" label="Transfer to Managed - Money Market" />
                <hsc-menu-item v-if="show(215)" label="Transfer to Managed - Property" />
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(219)" label="Transfer to Unmanaged - Bond" />
                <hsc-menu-item v-if="show(218)" label="Transfer to Unmanaged - Equity" />
                <hsc-menu-item v-if="show(220)" label="Transfer to Unmanaged - Money Market" />
                <hsc-menu-item v-if="show(221)" label="Transfer to Unmanaged - Property" />
            </hsc-menu-bar-item> -->
            <v-icon v-if="show(6)" v-on="on" small class="mb-1" color="#81DBF6">mdi-cash-multiple</v-icon>
            <hsc-menu-bar-item v-if="show(6)" label="Transactions">
                <hsc-menu-item v-if="show(601)" label="Contributions" @click="$router.push('/transactions/contributions')" />
                <hsc-menu-item v-if="show(602)" label="Withdrawal" @click="$router.push('/transactions/withdrawals')" />
                <hsc-menu-item v-if="show(603)" label="Credit Adjustment" @click="$router.push('/transactions/credit_adjustments')" />
                <hsc-menu-item v-if="show(604)" label="Debit Adjustment" @click="$router.push('/transactions/debit_adjustments')" />
                <hsc-menu-item v-if="show(3024)" label="Incomes">
                  <hsc-menu-item v-if="show(3024)" label="Dividends" @click="$router.push('/transactions/dividends')"/>
                  <hsc-menu-item v-if="show(3024)" label="Other Income" @click="$router.push('/transactions/income_transactions')" />
                </hsc-menu-item>
                <hsc-menu-item v-if="show(3025)" label="Settlements">
                  <hsc-menu-item v-if="show(3025)" label="Dividend Settlements" @click="$router.push('/transactions/dividend_settlements')"/>
                  <hsc-menu-item v-if="show(3025)" label="Fee Settlements" @click="$router.push('/transactions/fee_settlements')"/>
                  <hsc-menu-item v-if="show(3025)" label="Equity Settlements" @click="$router.push('/transactions/settlements')" />
                </hsc-menu-item>
                <!-- <hsc-menu-separator/>
                <hsc-menu-item v-if="show(901)" label="Call Enquiry" />
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(904)" label="Subscription" />
                <hsc-menu-item v-if="show(905)" label="Redemption" /> -->
                <!-- <hsc-menu-separator/>
                <hsc-menu-item v-if="show(907)" label="Stop Order Upload" /> -->
            </hsc-menu-bar-item>
            <!-- ChargeMapping and TradingModels missing -->
            <v-icon v-if="show(3)" v-on="on" small class="mb-1" color="#81DBF6">mdi-bullseye</v-icon>
            <hsc-menu-bar-item v-if="show(3)" label="Administration">
                <hsc-menu-item v-if="show(308)" label="Bonds" @click="$router.push('/administration/bonds')"/>
                <hsc-menu-item v-if="show(309)" label="Properties">
                    <hsc-menu-item v-if="show(309)" label="Properties" @click="$router.push('/administration/properties')"/>
                    <hsc-menu-item v-if="show(316)" label="Price & Valuation" @click="$router.push('/administration/property_prices')"/>
                </hsc-menu-item>
                <hsc-menu-item v-if="show(302)" label="Client Details" @click="$router.push('/administration/client_onboarding')">
                    <!-- <hsc-menu-item v-if="show(302)" label="Clients" @click="$router.push('/administration/client_onboarding')" /> -->
                    <!-- <hsc-menu-item v-if="show(3022)" label="Client Accounts" /> -->
                </hsc-menu-item>
                <!-- <hsc-menu-item v-if="show(304)" label="Counter Parties" @click="window.alert('Open')" />
                <hsc-menu-item v-if="show(307)" label="Profiles" @click="window.alert('Open')" />
                <hsc-menu-item v-if="show(301)" label="Dealers" @click="window.alert('New')" />
                <hsc-menu-item label="Equity Counters">
                    <hsc-menu-item v-if="show(303)" label="Public" />
                    <hsc-menu-item v-if="show(326)" label="Private" />
                </hsc-menu-item> -->
                <hsc-menu-item v-if="show(305)" label="Interest Bearing Instruments" @click="$router.push('/administration/instrument_types')" />
                <!-- <hsc-menu-item v-if="show(309)" label="Properties" @click="window.alert('Open')" />
                <hsc-menu-item v-if="show(398)" label="Price Upload" @click="window.alert('Open')">
                    <hsc-menu-item v-if="show(312)" label="Bond Prices" />
                    <hsc-menu-item v-if="show(314)" label="Equity Public Counter Prices" />
                    <hsc-menu-item v-if="show(316)" label="Property Values" />
                    <hsc-menu-item v-if="show(321)" label="Unit Trust Prices" />
                    <hsc-menu-item v-if="show(320)" label="Equity Private Counter Prices" />
                </hsc-menu-item> -->
                <hsc-menu-item v-if="show(399)" label="Rates" @click="window.alert('Open')">
                    <!-- <hsc-menu-item v-if="show(315)" label="Call Account Rates" /> -->
                    <!-- <hsc-menu-item v-if="show(312)" label="Counter Party Limits" @click="$router.push('/administration/counterparty_limits')" /> -->
                    <!-- <hsc-menu-item v-if="show(310)" label="Transaction Charge Rates" />
                    <hsc-menu-item v-if="show(913)" label="Account Fee Rates" /> -->
                    <hsc-menu-item v-if="show(399)" label="Exchange Rates" @click="$router.push('/administration/exchange_rates')"/>
                    <hsc-menu-item v-if="show(399)" label="Transaction Charge Rates" @click="$router.push('/administration/transactionchargerate')" />
                    <hsc-menu-item v-if="show(399)" label="Tax Rates" @click="$router.push('/administration/tax_rates')"/>
                    <hsc-menu-item v-if="show(399)" label="Money Market Rates" @click="$router.push('/administration/mm_rates')"/>
                    <hsc-menu-item v-if="show(399)" label="NMI Rebate Rates" @click="$router.push('/maintenance/nmi_rebate_rates')"/>
                </hsc-menu-item>
                <!-- <hsc-menu-separator/>
                <hsc-menu-item v-if="show(317)" label="Corporate Events"/>
                <hsc-menu-item v-if="show(318)" label="Corporate Event Application"/> -->
                <hsc-menu-separator/>
                <!-- <hsc-menu-item v-if="show(323)" label="Unit Trust Funds" />
                <hsc-menu-item v-if="show(324)" label="Income Distribution" /> -->
                <!-- <hsc-menu-item v-if="show(399)" label="Rates" @click="window.alert('Open')"/> -->
                <hsc-menu-item v-if="show(399)" label="Equities">
                  <hsc-menu-item v-if="show(303)" label="Public Equities" @click="$router.push('/administration/equities')" />
                  <hsc-menu-item v-if="show(314)" label="Public Equity Prices" @click="$router.push('/administration/equity_prices')" />
                  <hsc-menu-item v-if="show(326)" label="Private Equities" @click="$router.push('/administration/ul_equities')" />
                  <hsc-menu-item v-if="show(320)" label="Private Equity Prices" @click="$router.push('/administration/ul_equity_prices')" />
                </hsc-menu-item>
                <hsc-menu-item v-if="show(311)" label="Dealer Limits" @click="$router.push('/administration/dealer_limits')" />
                <hsc-menu-item v-if="show(325)" label="Charge Mapping" @click="$router.push('/administration/charge_mapping')" />
                <hsc-menu-item v-if="show(304)" label="Counter Parties" @click="$router.push('/administration/counter_parties')" />
                <hsc-menu-item v-if="show(3026)" label="Custodians" @click="$router.push('/administration/custodians')" />
                <hsc-menu-item v-if="show(301)" label="Dealers" @click="$router.push('/administration/dealers')" />
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(911)" label="Fees Management" @click="$router.push('/administration/fees_management')"/>
                <hsc-menu-item v-if="show(427)" label="Taxes" @click="$router.push('/administration/taxes')"/>
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(426)" label="Transaction Charges" @click="$router.push('/administration/transaction_charges')" />
                <hsc-menu-item v-if="show(3029)" label="Confirmation Settings" @click="$router.push('/administration/confirmation_settings')" />
            </hsc-menu-bar-item>
            <v-icon v-if="show(4)" v-on="on" small class="mb-1" color="#81DBF6">mdi-cog</v-icon>
            <hsc-menu-bar-item v-if="show(4)" label="Maintenance">
                <!-- <hsc-menu-item v-if="show(401)" label="Activations" @click="$router.push('/maintenance/activations')"/> -->
                <hsc-menu-item v-if="show(404)" label="Offices" @click="$router.push('/maintenance/offices')"/>
                <hsc-menu-item v-if="show(403)" label="Banks" @click="$router.push('/maintenance/banks')"/>
                <hsc-menu-item v-if="show(403)" label="Bank Branches" @click="$router.push('/maintenance/bank_branches')"/>
                <hsc-menu-item v-if="show(413)" label="Countries" @click="$router.push('/maintenance/countries')"/>
                <hsc-menu-item v-if="show(406)" label="Cities" @click="$router.push('/maintenance/cities')"/>
                <hsc-menu-item v-if="show(408)" label="Currencies" @click="$router.push('/maintenance/currencies')"/>
                <hsc-menu-item v-if="show(409)" label="Dealer Groups" @click="$router.push('/maintenance/dealer_groups')"/>
                <hsc-menu-item v-if="show(410)" label="Delivery Methods" @click="$router.push('/maintenance/delivery_methods')"/>
                <hsc-menu-item v-if="show(421)" label="Contribution Methods" @click="$router.push('/maintenance/contribution_methods')"/>
                <!-- <hsc-menu-item v-if="show(422)" label="Financial Years" @click="$router.push('/maintenance/financial_years')"/> -->
                <hsc-menu-item v-if="show(424)" label="Frequencies" @click="$router.push('/maintenance/frequencies')"/>
                <hsc-menu-item v-if="show(423)" label="Holidays" @click="$router.push('/maintenance/holidays')"/>
                <hsc-menu-item v-if="show(414)" label="Override Reasons" @click="$router.push('/maintenance/override_reasons')"/>
                <hsc-menu-item v-if="show(416)" label="Rejection Reasons" @click="$router.push('/maintenance/rejection_reasons')"/>
                <hsc-menu-item v-if="show(417)" label="Sectors" @click="$router.push('/maintenance/sectors')"/>
                <hsc-menu-separator/>
                <hsc-menu-item label="Status Settings">
                    <hsc-menu-item v-if="show(425)" label="Status Account" @click="$router.push('/maintenance/account_statuses')"/>
                    <hsc-menu-item v-if="show(418)" label="Status Custodians" @click="$router.push('/maintenance/custodian_statuses')"/>
                    <hsc-menu-item v-if="show(419)" label="Status Property" @click="$router.push('/maintenance/property_statuses')"/>
                </hsc-menu-item>
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(411)" label="Exchange Pairs" @click="$router.push('/maintenance/exchange_pairs')"/>
                <hsc-menu-item v-if="show(420)" label="Titles" @click="$router.push('/maintenance/titles')"/>
                <hsc-menu-separator/>
                <hsc-menu-item label="Types">
                    <hsc-menu-item v-if="show(402)" label="Bank Account Types" @click="$router.push('/maintenance/bank_account_types')"/>
                    <hsc-menu-item v-if="show(405)" label="Call Account Types" @click="$router.push('/maintenance/call_account_types')"/>
                    <hsc-menu-item v-if="show(407)" label="Client Types" @click="$router.push('/maintenance/client_types')"/>
                    <hsc-menu-item v-if="show(431)" label="Bond Investment Types" @click="$router.push('/maintenance/bond_investment_types')"/>
                    <hsc-menu-item v-if="show(412)" label="Identity Types" @click="$router.push('/maintenance/identity_types')"/>
                    <hsc-menu-item v-if="show(415)" label="Property Types" @click="$router.push('/maintenance/property_types')"/>
                </hsc-menu-item>
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(428)" label="Transaction Codes" @click="$router.push('/maintenance/transaction_codes')"/>
            </hsc-menu-bar-item>
            <v-icon v-if="show(5)" v-on="on" small class="mb-1" color="#81DBF6">mdi-security</v-icon>
            <hsc-menu-bar-item v-if="show(5)" label="Security">
                <hsc-menu-item v-if="show(501)" label="Users" @click="$router.push('/user_management')"/>
                <hsc-menu-item v-if="show(502)" label="Roles" @click="$router.push('/role_management')"/>
                <hsc-menu-item v-if="show(503)" label="General Security" @click="$router.push('/general_settings')"/>
            </hsc-menu-bar-item>
            <v-icon v-if="show(700)" v-on="on" small class="mb-1" color="#81DBF6">mdi-hammer-wrench</v-icon>
            <hsc-menu-bar-item v-if="show(700)" label="Tools">
                <hsc-menu-item v-if="show(701)" label="Period End" @click="$router.push('/tools/period_end')"/>
                <!-- <hsc-menu-separator/>
                <hsc-menu-item v-if="show(703)" label="Period Defination" @click="$router.push('/tools/period_definations')"/> -->
                <!-- <hsc-menu-separator/>
                <hsc-menu-item v-if="show(504)" label="Confirmation Settings"/> -->
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(712)" label="System Defaults" @click="$router.push('/tools/application_defaults')"/>
                <!-- <hsc-menu-separator/>
                <hsc-menu-item v-if="show(716)" label="General Settings" @click="$router.push('/image_upload')"/> -->
                <!-- <hsc-menu-separator/>
                <hsc-menu-item v-if="show(713)" label="Audit Trail"/>
                <hsc-menu-item v-if="show(720)" label="Notification Services">
                    <hsc-menu-item v-if="show(721)" label="Mail Server Settings"/>
                    <hsc-menu-item v-if="show(722)" label="Message Settings"/>
                    <hsc-menu-item v-if="show(723)" label="Monthly Reports"/>
                    <hsc-menu-item v-if="show(724)" label="Targeted Mailing"/>
                </hsc-menu-item>
                <hsc-menu-item v-if="show(740)" label="Maturities"/> -->
            </hsc-menu-bar-item>
            <v-icon v-if="show(3028)" v-on="on" small class="mb-1" color="#81DBF6">mdi-file-document</v-icon>
            <hsc-menu-bar-item v-if="show(3028)" label="Reports">
                <hsc-menu-item v-if="show(3028)" label="Clients">
                    <hsc-menu-item v-if="show(3028)" label="Listings" @click="$router.push('/reports/client_listing')"/>
                    <hsc-menu-item v-if="show(3028)" label="Clients Custodians" @click="$router.push('/reports/client_custodians')"/>
                    <hsc-menu-item v-if="show(3028)" label="KYC" @click="$router.push('/reports/kyc_report')"/>
                    <!-- <hsc-menu-item v-if="show(723)" label="Funds Under Management"/> -->
                </hsc-menu-item>
                <hsc-menu-item v-if="show(3028)" label="Accounts">
                    <hsc-menu-item v-if="show(3028)" label="Fees" @click="$router.push('/reports/client_fees')"/>
                    <hsc-menu-item v-if="show(3028)" label="Charges"/>
                </hsc-menu-item>
                <hsc-menu-item v-if="show(3028)" label="Deals">
                    <hsc-menu-item v-if="show(3028)" label="Pending Deals" @click="$router.push('/reports/pending_deals')"/>
                    <hsc-menu-item v-if="show(3028)" label="Maturity Report" @click="$router.push('/reports/financial_maturity_report')"/>
                </hsc-menu-item>
                <hsc-menu-item v-if="show(3028)" label="Financials">
                    <!-- <hsc-menu-item v-if="show(721)" label="Portfolio Statement" @click="$router.push('/reports/portfolio_statement')"/> -->
                    <hsc-menu-item v-if="show(3028)" label="Financial Entries" @click="$router.push('/reports/financial_entries')"/>
                    <hsc-menu-item v-if="show(3028)" label="Financial Account Statement" @click="$router.push('/reports/financial_account_statement')"/>
                    <hsc-menu-item v-if="show(3028)" label="Client Valuation" @click="$router.push('/reports/client_valuation')"/>
                    <!-- <hsc-menu-item v-if="show(723)" label="Valuations"/>
                    <hsc-menu-item v-if="show(723)" label="Book Values"/>
                    <hsc-menu-item v-if="show(723)" label="Income Report"/>
                    <hsc-menu-item v-if="show(723)" label="Tax Rport"/> -->
                </hsc-menu-item>
                <!-- <hsc-menu-item v-if="show(3028)" label="Unit Trusts">
                    <hsc-menu-item v-if="show(3028)" label="Client Funds Under Management" @click="$router.push('/reports/client_fum')"/>
                </hsc-menu-item> -->
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(3028)" label="Transaction Statement" @click="$router.push('/reports/generated_entries')"/>
                <hsc-menu-item v-if="show(3028)" label="Income and Expenses" @click="$router.push('/reports/income_paid')"/>
                <hsc-menu-item v-if="show(3028)" label="Interest Bearing Assets" @click="$router.push('/reports/interest_bearing_assets')"/>
                <hsc-menu-item v-if="show(3028)" label="Consolidated Valuation" @click="$router.push('/reports/consolidated_valuation')"/>
                <hsc-menu-item v-if="show(3028)" label="NMI Rebate Rates" @click="$router.push('/reports/nmi_rebate_rates')"/>
                <!-- <hsc-menu-item v-if="show(720)" label="Security">
                    <hsc-menu-item v-if="show(721)" label="Audit Trail"/>
                    <hsc-menu-item v-if="show(722)" label="User Roles & Rights"/>
                </hsc-menu-item> -->
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(3028)" label="Trading Margin">
                    <hsc-menu-item v-if="show(3028)" label="Deals" @click="$router.push('/reports/trading_margins')"/>
                    <hsc-menu-item v-if="show(3028)" label="Client Allocations" @click="$router.push('/reports/trading_margin_allocations')"/>
                </hsc-menu-item>
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(3028)" label="Accruals">
                    <hsc-menu-item v-if="show(3028)" label="Assets" @click="$router.push('/reports/accruals_assets')"/>
                    <hsc-menu-item v-if="show(3028)" label="Liabilities" @click="$router.push('/reports/accruals_liabilities')"/>
                </hsc-menu-item>
                <hsc-menu-item v-if="show(3028)" label="Equity Holding" @click="$router.push('/reports/equity_holdingls')"/>
                <hsc-menu-item v-if="show(3028)" label="Transaction History" @click="$router.push('/reports/transaction_history')"/>
                <hsc-menu-item v-if="show(3028)" label="Counterparty Exposure" @click="$router.push('/reports/counterparty_exposure')"/>
                <hsc-menu-separator/>
                <hsc-menu-item v-if="show(3028)" label="Other">
                  <hsc-menu-item v-if="show(3028)" label="Money Market Trading Rates" @click="$router.push('/reports/mm_rates_rpt')"/>
                  <hsc-menu-item v-if="show(3028)" label="Purchases, Sales and Maturities" @click="$router.push('/reports/purchase_sales&maturities')"/>
                  <hsc-menu-item v-if="show(3028)" label="Equities Holdings" @click="$router.push('/reports/equities_holdings')"/>
                  <hsc-menu-item v-if="show(3028)" label="Contributions and Withdrawals" @click="$router.push('/reports/contribution_withdrawals')"/>
                  <hsc-menu-item v-if="show(3028)" label="Outstanding Settlements" @click="$router.push('/reports/settlement_report')"/>
                  <hsc-menu-item v-if="show(3028)" label="Individual Outstanding Settlements" @click="$router.push('/reports/ind_outstanding_settlements')"/>
                  <hsc-menu-item v-if="show(3028)" label="Performance Report" @click="$router.push('/reports/performance')"/>
                  <hsc-menu-item v-if="show(3028)" label="Performance for Assets Report" @click="$router.push('/reports/asset_performance')"/>
                  <hsc-menu-item v-if="show(3028)" label="Audit Trail" @click="$router.push('/reports/audit_trail')"/>
                </hsc-menu-item>
            </hsc-menu-bar-item>
        </hsc-menu-bar>
    </hsc-menu-style-white>
</template>

<script>

export default {
  name: 'NavBar',

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    show(info) {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === info).map(r => r.AllowView)) == 1){
        return true
      }
    }
    return false;
    },
  },
  mounted () {
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MAINTENANCE

    this.$root.$on("Activations", () => {
      if(this.currentRoute == '/maintenance/activations'){
        this.$root.$emit("unconfirmedActivations")
      } else {
        this.$router.push('/maintenance/activations')
        .then(() => {
          this.$root.$emit("unconfirmedActivations")
        })
      }
    });
    this.$root.$on("Bank Account Types", () => {
      if(this.currentRoute == '/maintenance/bank_account_types'){
        this.$root.$emit("unconfirmedBankAccountTypes")
      } else {
        this.$router.push('/maintenance/bank_account_types')
        .then(() => {
          this.$root.$emit("unconfirmedBankAccountTypes")
        })
      }
    });
    this.$root.$on("Banks", () => {
      if(this.currentRoute == '/maintenance/banks'){
        this.$root.$emit("unconfirmedBanks")
      } else {
        this.$router.push('/maintenance/banks')
        .then(() => {
          this.$root.$emit("unconfirmedBanks")
        })
      }
    });
    this.$root.$on("Bank Branches", () => {
      if(this.currentRoute == '/maintenance/bank_branches'){
        this.$root.$emit("unconfirmedBranches")
      } else {
        this.$router.push('/maintenance/bank_branches')
        .then(() => {
          this.$root.$emit("unconfirmedBranches")
        })
      }
    });
    this.$root.$on("Bond Investment Types", () => {
      if(this.currentRoute == '/maintenance/bond_investment_types'){
        this.$root.$emit("unconfirmedBondInvestmentTypes")
      } else {
        this.$router.push('/maintenance/bond_investment_types')
        .then(() => {
          this.$root.$emit("unconfirmedBondInvestmentTypes")
        })
      }
    });
    this.$root.$on("Call Account Types", () => {
      if(this.currentRoute == '/maintenance/call_account_types'){
        this.$root.$emit("unconfirmedCallAccountTypes")
      } else {
        this.$router.push('/maintenance/call_account_types')
        .then(() => {
          this.$root.$emit("unconfirmedCallAccountTypes")
        })
      }
    });
    this.$root.$on("Cities", () => {
      if(this.currentRoute == '/maintenance/cities'){
        this.$root.$emit("unconfirmedCities")
      } else {
        this.$router.push('/maintenance/cities')
        .then(() => {
          this.$root.$emit("unconfirmedCities")
        })
      }
    });
    this.$root.$on("Client Types", () => {
      if(this.currentRoute == '/maintenance/client_types'){
        this.$root.$emit("unconfirmedClientTypes")
      } else {
        this.$router.push('/maintenance/client_types')
        .then(() => {
          this.$root.$emit("unconfirmedClientTypes")
        })
      }
    });
    this.$root.$on("Countries", () => {
      if(this.currentRoute == '/maintenance/countries'){
        this.$root.$emit("unconfirmedCountries")
      } else {
        this.$router.push('/maintenance/countries')
        .then(() => {
          this.$root.$emit("unconfirmedCountries")
        })
      }
    });
    this.$root.$on("Currencies", () => {
      if(this.currentRoute == '/maintenance/currencies'){
        this.$root.$emit("unconfirmedCurrencies")
      } else {
        this.$router.push('/maintenance/currencies')
        .then(() => {
          this.$root.$emit("unconfirmedCurrencies")
        })
      }
    });
    this.$root.$on("Custodian Statuses", () => {
      if(this.currentRoute == '/maintenance/custodian_statuses'){
        this.$root.$emit("unconfirmedCustodianStatuses")
      } else {
        this.$router.push('/maintenance/custodian_statuses')
        .then(() => {
          this.$root.$emit("unconfirmedCustodianStatuses")
        })
      }
    });
    this.$root.$on("Dealer Groups", () => {
      if(this.currentRoute == '/maintenance/dealer_groups'){
        this.$root.$emit("unconfirmedDealerGroups")
      } else {
        this.$router.push('/maintenance/dealer_groups')
        .then(() => {
          this.$root.$emit("unconfirmedDealerGroups")
        })
      }
    });
    this.$root.$on("Delivery Methods", () => {
      if(this.currentRoute == '/maintenance/delivery_methods'){
        this.$root.$emit("unconfirmedDeliveryMethods")
      } else {
        this.$router.push('/maintenance/delivery_methods')
        .then(() => {
          this.$root.$emit("unconfirmedDeliveryMethods")
        })
      }
    });
    this.$root.$on("Deposit Methods", () => {
      if(this.currentRoute == '/maintenance/contribution_methods'){
        this.$root.$emit("unconfirmedDepositMethods")
      } else {
        this.$router.push('/maintenance/contribution_methods')
        .then(() => {
          this.$root.$emit("unconfirmedDepositMethods")
        })
      }
    });
    this.$root.$on("Exchange Pairs", () => {
      if(this.currentRoute == '/maintenance/exchange_pairs'){
        this.$root.$emit("unconfirmedExchangePairs")
      } else {
        this.$router.push('/maintenance/exchange_pairs')
        .then(() => {
          this.$root.$emit("unconfirmedExchangePairs")
        })
      }
    });
    this.$root.$on("Financial Years", () => {
      if(this.currentRoute == '/maintenance/financial_years'){
        this.$root.$emit("unconfirmedFinancialYears")
      } else {
        this.$router.push('/maintenance/financial_years')
        .then(() => {
          this.$root.$emit("unconfirmedFinancialYears")
        })
      }
    });
    this.$root.$on("Frequencies", () => {
      if(this.currentRoute == '/maintenance/frequencies'){
        this.$root.$emit("unconfirmedFrequencies")
      } else {
        this.$router.push('/maintenance/frequencies')
        .then(() => {
          this.$root.$emit("unconfirmedFrequencies")
        })
      }
    });
    this.$root.$on("Holidays", () => {
      if(this.currentRoute == '/maintenance/holidays'){
        this.$root.$emit("unconfirmedHolidays")
      } else {
        this.$router.push('/maintenance/holidays')
        .then(() => {
          this.$root.$emit("unconfirmedHolidays")
        })
      }
    });
    this.$root.$on("Identity Types", () => {
      if(this.currentRoute == '/maintenance/identity_types'){
        this.$root.$emit("unconfirmedIdentityTypes")
      } else {
        this.$router.push('/maintenance/identity_types')
        .then(() => {
          this.$root.$emit("unconfirmedIdentityTypes")
        })
      }
    });
    this.$root.$on("Offices", () => {
      if(this.currentRoute == '/maintenance/offices'){
        this.$root.$emit("unconfirmedOffices")
      } else {
        this.$router.push('/maintenance/offices')
        .then(() => {
          this.$root.$emit("unconfirmedOffices")
        })
      }
    });
    this.$root.$on("NMI Rebate Rates", () => {
      if(this.currentRoute == '/maintenance/nmi_rebate_rates'){
        this.$root.$emit("unconfirmedNMIRebates")
      } else {
        this.$router.push('/maintenance/nmi_rebate_rates')
        .then(() => {
          this.$root.$emit("unconfirmedNMIRebates")
        })
      }
    });
    this.$root.$on("Override Reasons", () => {
      if(this.currentRoute == '/maintenance/override_reasons'){
        this.$root.$emit("unconfirmedOverrideReasons")
      } else {
        this.$router.push('/maintenance/override_reasons')
        .then(() => {
          this.$root.$emit("unconfirmedOverrideReasons")
        })
      }
    });
    this.$root.$on("Property Statuses", () => {
      if(this.currentRoute == '/maintenance/property_statuses'){
        this.$root.$emit("unconfirmedPropertyStatuses")
      } else {
        this.$router.push('/maintenance/property_statuses')
        .then(() => {
          this.$root.$emit("unconfirmedPropertyStatuses")
        })
      }
    });
    this.$root.$on("Property Types", () => {
      if(this.currentRoute == '/maintenance/property_types'){
        this.$root.$emit("unconfirmedPropertyTypes")
      } else {
        this.$router.push('/maintenance/property_types')
        .then(() => {
          this.$root.$emit("unconfirmedPropertyTypes")
        })
      }
    });
    this.$root.$on("Rejection Reasons", () => {
      if(this.currentRoute == '/maintenance/rejection_reasons'){
        this.$root.$emit("unconfirmedRejectionReasons")
      } else {
        this.$router.push('/maintenance/rejection_reasons')
        .then(() => {
          this.$root.$emit("unconfirmedRejectionReasons")
        })
      }
    });
    this.$root.$on("Sectors", () => {
      if(this.currentRoute == '/maintenance/sectors'){
        this.$root.$emit("unconfirmedSectors")
      } else {
        this.$router.push('/maintenance/sectors')
        .then(() => {
          this.$root.$emit("unconfirmedSectors")
        })
      }
    });
    this.$root.$on("Titles", () => {
      if(this.currentRoute == '/maintenance/titles'){
        this.$root.$emit("unconfirmedTitles")
      } else {
        this.$router.push('/maintenance/titles')
        .then(() => {
          this.$root.$emit("unconfirmedTitles")
        })
      }
    });
    this.$root.$on("Transaction Codes", () => {
      if(this.currentRoute == '/maintenance/transaction_codes'){
        this.$root.$emit("unconfirmedTransactionCodes")
      } else {
        this.$router.push('/maintenance/transaction_codes')
        .then(() => {
          this.$root.$emit("unconfirmedTransactionCodes")
        })
      }
    });
    this.$root.$on("Account Statuses", () => {
      if(this.currentRoute == '/maintenance/account_statuses'){
        this.$root.$emit("unconfirmedAccountStatuses")
      } else {
        this.$router.push('/maintenance/account_statuses')
        .then(() => {
          this.$root.$emit("unconfirmedAccountStatuses")
        })
      }
    });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SECURITY

    this.$root.$on("Roles", () => {
      if(this.currentRoute == '/role_management'){
        this.$root.$emit("unconfirmedRoles")
      } else {
        this.$router.push('/role_management')
        .then(() => {
          this.$root.$emit("unconfirmedRoles")
        })
      }
    });
    this.$root.$on("Users", () => {
      if(this.currentRoute == '/user_management'){
        this.$root.$emit("unconfirmedUsers")
      } else {
        this.$router.push('/user_management')
        .then(() => {
          this.$root.$emit("unconfirmedUsers")
        })
      }
    });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ADMINISTRATION


    this.$root.$on("Unit Trust Funds", () => {
      if(this.currentRoute == '/administration/unit_trust'){
        this.$root.$emit("unconfirmedUnitTrustFunds")
      } else {
        this.$router.push('/administration/unit_trust')
        .then(() => {
          this.$root.$emit("unconfirmedUnitTrustFunds")
        })
      }
    });
    this.$root.$on("Unit Trust Redemptions", () => {
      if(this.currentRoute == '/administration/unit_trust_redemption'){
        this.$root.$emit("unconfirmedUnitTrustRedemptions")
      } else {
        this.$router.push('/administration/unit_trust_redemption')
        .then(() => {
          this.$root.$emit("unconfirmedUnitTrustRedemptions")
        })
      }
    });
    this.$root.$on("Unit Trust Subscriptions", () => {
      if(this.currentRoute == '/administration/unit_trust_subscription'){
        this.$root.$emit("unconfirmedUnitTrustSubscriptions")
      } else {
        this.$router.push('/administration/unit_trust_subscription')
        .then(() => {
          this.$root.$emit("unconfirmedUnitTrustSubscriptions")
        })
      }
    });
    this.$root.$on("Unit Distributions", () => {
      if(this.currentRoute == '/administration/unit_distribution'){
        this.$root.$emit("unconfirmedUnitDistributions")
      } else {
        this.$router.push('/administration/unit_distribution')
        .then(() => {
          this.$root.$emit("unconfirmedUnitDistributions")
        })
      }
    });
    this.$root.$on("Counterparty Limits", () => {
      if(this.currentRoute == '/administration/counterparty_limits'){
        this.$root.$emit("unconfirmedCounterpartyLimits")
      } else {
        this.$router.push('/administration/counterparty_limits')
        .then(() => {
          this.$root.$emit("unconfirmedCounterpartyLimits")
        })
      }
    });
    this.$root.$on("Dealer Limits", () => {
      if(this.currentRoute == '/administration/dealer_limits'){
        this.$root.$emit("unconfirmedDealerLimits")
      } else {
        this.$router.push('/administration/dealer_limits')
        .then(() => {
          this.$root.$emit("unconfirmedDealerLimits")
        })
      }
    });
    this.$root.$on("Tax Rates", () => {
      if(this.currentRoute == '/administration/tax_rates'){
        this.$root.$emit("unconfirmedTaxRates")
      } else {
        this.$router.push('/administration/tax_rates')
        .then(() => {
          this.$root.$emit("unconfirmedTaxRates")
        })
      }
    });
    this.$root.$on("Taxes", () => {
      if(this.currentRoute == '/administration/taxes'){
        this.$root.$emit("unconfirmedTaxes")
      } else {
        this.$router.push('/administration/taxes')
        .then(() => {
          this.$root.$emit("unconfirmedTaxes")
        })
      }
    });
    this.$root.$on("Money Market Rates", () => {
      if(this.currentRoute == '/administration/mm_rates'){
        this.$root.$emit("unconfirmedMMRates")
      } else {
        this.$router.push('/administration/mm_rates')
        .then(() => {
          this.$root.$emit("unconfirmedMMRates")
        })
      }
    });
    this.$root.$on("Clients", () => {
      if(this.currentRoute == '/administration/client_onboarding'){
        this.$root.$emit("unconfirmedClients")
      } else {
        this.$router.push('/administration/client_onboarding')
        .then(() => {
          this.$root.$emit("unconfirmedClients")
        })
      }
    });
    this.$root.$on("Client Accounts", () => {
      if(this.currentRoute == '/administration/client_onboarding'){
        this.$root.$emit("unconfirmedClientAccounts")
      } else {
        this.$router.push('/administration/client_onboarding')
        .then(() => {
          this.$root.$emit("unconfirmedClientAccounts")
        })
      }
    });
    this.$root.$on("Client Contacts", () => {
      if(this.currentRoute == '/administration/client_onboarding'){
        this.$root.$emit("unconfirmedClientContacts")
      } else {
        this.$router.push('/administration/client_onboarding')
        .then(() => {
          this.$root.$emit("unconfirmedClientContacts")
        })
      }
    });
    this.$root.$on("Client Signatories", () => {
      if(this.currentRoute == '/administration/client_onboarding'){
        this.$root.$emit("unconfirmedClientSignatories")
      } else {
        this.$router.push('/administration/client_onboarding')
        .then(() => {
          this.$root.$emit("unconfirmedClientSignatories")
        })
      }
    });
    this.$root.$on("Fees Management", () => {
      if(this.currentRoute == '/administration/fees_management'){
        this.$root.$emit("unconfirmedFees")
      } else {
        this.$router.push('/administration/fees_management')
        .then(() => {
          this.$root.$emit("unconfirmedFees")
        })
      }
    });
    this.$root.$on("Transaction Charges", () => {
      if(this.currentRoute == '/administration/transaction_charges'){
        this.$root.$emit("unconfirmedTransactionCharges")
      } else {
        this.$router.push('/administration/transaction_charges')
        .then(() => {
          this.$root.$emit("unconfirmedTransactionCharges")
        })
      }
    });
    this.$root.$on("Charge Mappings", () => {
      if(this.currentRoute == '/administration/charge_mapping'){
        this.$root.$emit("unconfirmedEventMappings")
      } else {
        this.$router.push('/administration/charge_mapping')
        .then(() => {
          this.$root.$emit("unconfirmedEventMappings")
        })
      }
    });
    this.$root.$on("Custodians", () => {
      if(this.currentRoute == '/administration/custodians'){
        this.$root.$emit("unconfirmedCustodians")
      } else {
        this.$router.push('/administration/custodians')
        .then(() => {
          this.$root.$emit("unconfirmedCustodians")
        })
      }
    });
    this.$root.$on("Transaction Charge Rates", () => {
      if(this.currentRoute == '/administration/transactionchargerate'){
        this.$root.$emit("unconfirmedTransactionChargeRates")
      } else {
        this.$router.push('/administration/transactionchargerate')
        .then(() => {
          this.$root.$emit("unconfirmedTransactionChargeRates")
        })
      }
    });
    this.$root.$on("Equities", () => {
      if(this.currentRoute == '/administration/equities'){
        this.$root.$emit("unconfirmedEquities")
      } else {
        this.$router.push('/administration/equities')
        .then(() => {
          this.$root.$emit("unconfirmedEquities")
        })
      }
    });
    this.$root.$on("Unlisted Equities", () => {
      if(this.currentRoute == '/administration/ul_equities'){
        this.$root.$emit("unconfirmedUlEquities")
      } else {
        this.$router.push('/administration/ul_equities')
        .then(() => {
          this.$root.$emit("unconfirmedUlEquities")
        })
      }
    });
    this.$root.$on("Bonds", () => {
      if(this.currentRoute == '/administration/bonds'){
        this.$root.$emit("unconfirmedBonds")
      } else {
        this.$router.push('/administration/bonds')
        .then(() => {
          this.$root.$emit("unconfirmedBonds")
        })
      }
    });
    this.$root.$on("Properties", () => {
      if(this.currentRoute == '/administration/properties'){
        this.$root.$emit("unconfirmedProperties")
      } else {
        this.$router.push('/administration/properties')
        .then(() => {
          this.$root.$emit("unconfirmedProperties")
        })
      }
    });
    this.$root.$on("Property Prices", () => {
      if(this.currentRoute == '/administration/property_prices'){
        this.$root.$emit("unconfirmedPropertyValues")
      } else {
        this.$router.push('/administration/property_prices')
        .then(() => {
          this.$root.$emit("unconfirmedPropertyValues")
        })
      }
    });
    this.$root.$on("Counterparties", () => {
      if(this.currentRoute == '/administration/counter_parties'){
        this.$root.$emit("unconfirmedCounterParties")
      } else {
        this.$router.push('/administration/counter_parties')
        .then(() => {
          this.$root.$emit("unconfirmedCounterParties")
        })
      }
    });
    this.$root.$on("Exchange Rates", () => {
      if(this.currentRoute == '/administration/exchange_rates'){
        this.$root.$emit("unconfirmedDailyExchanges")
      } else {
        this.$router.push('/administration/exchange_rates')
        .then(() => {
          this.$root.$emit("unconfirmedDailyExchanges")
        })
      }
    });
    this.$root.$on("Dealers", () => {
      if(this.currentRoute == '/administration/dealers'){
        this.$root.$emit("unconfirmedDealers")
      } else {
        this.$router.push('/administration/dealers')
        .then(() => {
          this.$root.$emit("unconfirmedDealers")
        })
      }
    });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TOOLS

    this.$root.$on("Periods", () => {
      if(this.currentRoute == '/tools/period_definations'){
        this.$root.$emit("unconfirmedPeriods")
      } else {
        this.$router.push('/tools/period_definations')
        .then(() => {
          this.$root.$emit("unconfirmedPeriods")
        })
      }
    });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTIONS

    this.$root.$on("Contributions", () => {
      if(this.currentRoute == '/transactions/contributions'){
        this.$root.$emit("unconfirmedDeposits")
      } else {
        this.$router.push('/transactions/contributions')
        .then(() => {
          this.$root.$emit("unconfirmedDeposits")
        })
      }
    });
    this.$root.$on("Withdrawals", () => {
      if(this.currentRoute == '/transactions/withdrawals'){
        this.$root.$emit("unconfirmedWithdrawals")
      } else {
        this.$router.push('/transactions/withdrawals')
        .then(() => {
          this.$root.$emit("unconfirmedWithdrawals")
        })
      }
    });
    this.$root.$on("Credit Adjustments", () => {
      if(this.currentRoute == '/transactions/credit_adjustments'){
        this.$root.$emit("unconfirmedCreditAdjustments")
      } else {
        this.$router.push('/transactions/credit_adjustments')
        .then(() => {
          this.$root.$emit("unconfirmedCreditAdjustments")
        })
      }
    });
    this.$root.$on("Debit Adjustments", () => {
      if(this.currentRoute == '/transactions/debit_adjustments'){
        this.$root.$emit("unconfirmedDebitAdjustments")
      } else {
        this.$router.push('/transactions/debit_adjustments')
        .then(() => {
          this.$root.$emit("unconfirmedDebitAdjustments")
        })
      }
    });
    this.$root.$on("Income Transactions", () => {
      if(this.currentRoute == '/transactions/income_transactions'){
        this.$root.$emit("unconfirmedIncomeTransactions")
      } else {
        this.$router.push('/transactions/income_transactions')
        .then(() => {
          this.$root.$emit("unconfirmedIncomeTransactions")
        })
      }
    });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALING

    this.$root.$on("Bond Purchases", () => {
      if(this.currentRoute == '/dealing/bond_purchases'){
        this.$root.$emit("unconfirmedBondPurchases")
      } else {
        this.$router.push('/dealing/bond_purchases')
        .then(() => {
          this.$root.$emit("unconfirmedBondPurchases")
        })
      }
    });
    this.$root.$on("Equity Purchases", () => {
      if(this.currentRoute == '/dealing/equity_purchases'){
        this.$root.$emit("unconfirmedEquityPurchases")
      } else {
        this.$router.push('/dealing/equity_purchases')
        .then(() => {
          this.$root.$emit("unconfirmedEquityPurchases")
        })
      }
    });
    this.$root.$on("Money Market Purchases", () => {
      if(this.currentRoute == '/dealing/MM_purchases'){
        this.$root.$emit("unconfirmedMMPurchases")
      } else {
        this.$router.push('/dealing/MM_purchases')
        .then(() => {
          this.$root.$emit("unconfirmedMMPurchases")
        })
      }
    });
    this.$root.$on("Property Purchases", () => {
      if(this.currentRoute == '/dealing/property_purchases'){
        this.$root.$emit("unconfirmedPropertyPurchases")
      } else {
        this.$router.push('/dealing/property_purchases')
        .then(() => {
          this.$root.$emit("unconfirmedPropertyPurchases")
        })
      }
    });
    this.$root.$on("Bond Sales", () => {
      if(this.currentRoute == '/dealing/bond_sales'){
        this.$root.$emit("unconfirmedBondSales")
      } else {
        this.$router.push('/dealing/bond_sales')
        .then(() => {
          this.$root.$emit("unconfirmedBondSales")
        })
      }
    });
    this.$root.$on("Equity Sales", () => {
      if(this.currentRoute == '/dealing/equity_sales'){
        this.$root.$emit("unconfirmedEquitySales")
      } else {
        this.$router.push('/dealing/equity_sales')
        .then(() => {
          this.$root.$emit("unconfirmedEquitySales")
        })
      }
    });
    this.$root.$on("Money Market Sales", () => {
      if(this.currentRoute == '/dealing/MM_sales'){
        this.$root.$emit("unconfirmedMMSales")
      } else {
        this.$router.push('/dealing/MM_sales')
        .then(() => {
          this.$root.$emit("unconfirmedMMSales")
        })
      }
    });
    this.$root.$on("Property Sales", () => {
      if(this.currentRoute == '/dealing/property_sales'){
        this.$root.$emit("unconfirmedPropertySales")
      } else {
        this.$router.push('/dealing/property_sales')
        .then(() => {
          this.$root.$emit("unconfirmedPropertySales")
        })
      }
    });
    this.$root.$on("Internal Asset Transfers", () => {
      if(this.currentRoute == '/dealing/internal_asset_transfer'){
        this.$root.$emit("unconfirmedAssetTransfers")
      } else {
        this.$router.push('/dealing/internal_asset_transfer')
        .then(() => {
          this.$root.$emit("unconfirmedAssetTransfers")
        })
      }
    });
    this.$root.$on("Reversals", () => {
      if(this.currentRoute == '/dealing/reversals'){
        this.$root.$emit("unconfirmedReversals")
      } else {
        this.$router.push('/dealing/reversals')
        .then(() => {
          this.$root.$emit("unconfirmedReversals")
        })
      }
    });
  },
}
</script>